import type { LinkStylesProps } from '~/styles/link';
import { Span } from '@workramp/ui';
import styled from 'styled-components';
import { linkStyles } from '~/styles/link';

type UserListItemWrapperProps = {
  $cursor: 'pointer' | 'not-allowed' | 'auto';
};

export const UserListItemWrapper = styled.div<UserListItemWrapperProps>`
  display: flex;
  column-gap: ${({ theme }) => theme.spacing(2)}px;
  padding: ${({ theme }) => theme.spacing(2)}px;
  box-sizing: border-box;
  width: 100%;
  border: none;
  background-color: #fff;
  align-items: center;

  cursor: ${({ $cursor }) => $cursor};

  ${({ theme, $cursor }) =>
    $cursor === 'pointer' &&
    `
      &:hover {
        background-color: ${theme.colors.secondary[50]};
      }
    `}

  & > &:first-child {
    flex-shrink: 0;
  }
`;

export const UserInfoWrapper = styled.div<LinkStylesProps & { $isLink?: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;

  ${({ $isLink }) => $isLink && linkStyles}
`;

export const TrailingButtonWrapper = styled.div`
  margin-left: auto;
`;

export const UserLabel = styled(Span)`
  color: ${({ theme }) => theme.colors.on[400]};
`;
